import Utils from 'helpers/utils';

const validateInput = ({ username, password, rePassword, signUp = false }) => {
  if (!username) return { error: 'Username is not empty' };
  if (!password) return { error: 'Password is not empty' };
  if (signUp && password !== rePassword) {
    return { error: 'Re-enter password does not match' };
  }
  if (!Utils.validateEmail(username)) {
    return { error: 'Invalid email address' };
  }
  return {};
};

export default { validateInput };
